import React from 'react';
import { GoArrowLeft } from "react-icons/go";
import { useNavigate } from "react-router-dom";


// PageHeader now supports hideBack prop to suppress the back button (e.g. first landing after login)
// Also supports onBack prop for custom back navigation
const PageHeader = ({ 
  title, 
  className = "text-white",
  iconClassName = "text-white",
  titleClassName = "text-lg font-normal text-white",
  hideBack = false,
  onBack
}) => {
  const navigate = useNavigate();
  
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      // Always navigate to home page instead of browser back
      navigate('/home');
    }
  };

  return (
    <div className={`flex items-center ${className}`}>
      {!hideBack && (
        <button onClick={handleBack} className={`mr-4 ${iconClassName}`}>
          <GoArrowLeft />
        </button>
      )}
      <h1 className={titleClassName}>{title}</h1>
    </div>
  );
};

export default PageHeader; 